import PropTypes from 'prop-types';
import React from 'react';

const Machine = '/icons/image-machine.png';
const Calendar = '/icons/image-calendar.png';
const Desktop = '/icons/image-desktop.png';
import {AccreditationButton} from '../AccreditationButton';
import './Benefits.style.scss';

export const Benefits = (props) => {
  return (
    <div className="benefits" id="vantagens">
      <div className="benefits__content">
        <h2 className="benefits__title">
          Te ajudar a crescer faz parte do nosso propósito!
        </h2>
        <p className="benefits__text">
          Por isso, ser um estabelecimento comercial credenciado à Alelo,
          garante mais visibilidade para você, além de soluções que vão te
          ajudar com o gestão do seu negócio, a divulgação dos seus produtos e
          muito mais!
        </p>
      </div>

      <div className="card">
        <div className="card__background card--light-green" />
        <div className="card__body">
          <div className="card__content">
            <div className="card__texts">
              <h3 className="card__title">Ampla rede de aceitação!</h3>
              <p>
                Seja parceiro de uma empresa líder de mercado, que movimenta{' '}
                <strong>55 milhões de transações</strong> por mês e conta com{' '}
                <strong>10 milhões de usuários.</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="card__image">
          <img src={Machine} alt="Maquinada de Cartão" />
        </div>
      </div>

      <div className="card">
        <div className="card__background-inverse card--lime-green" />
        <div className="card__body">
          <div className="card__content">
            <div className="card--float-right">
              <div className="card__texts-inverse">
                <h3 className="card__title-inverse">
                  Antecipação de Recebíveis
                </h3>
                <p>
                  <strong>Receba o valor das suas vendas</strong> de forma
                  rápida e prática, <strong>em até 24 horas.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="card__image-calendar">
          <img src={Calendar} alt="Calendário" />
        </div>
      </div>

      <div className="card">
        <div className="card__background card--dark-green" />
        <div className="card__body">
          <div className="card__content">
            <div className="card__texts">
              <h3 className="card__title">Parcerias</h3>
              <p>
                <strong>Transforme o dia a dia do seu comércio</strong> e
                alavanque o sucesso do seu negócio com a nossa rede de
                parcerias.
              </p>
            </div>
          </div>
          <div className="accreditation-button-box-card">
            <AccreditationButton
              {...props}
              elementType="box:button:click"
              elementContent="none:quero-me-credenciar:multisservicos"
            />
          </div>
        </div>
        <div className="card__image-desktop">
          <img src={Desktop} alt="Área de trabalho" />
        </div>
      </div>

      <div className="card__image-mobile">
        <img src={Machine} alt="Maquinada de Cartão" />
      </div>
    </div>
  );
};

Benefits.propTypes = {
  buttonFunctionShowAccreditation: PropTypes.func
};
